module.exports = __webpack_public_path__ + "fa5a18c4822fcf5765bdb330e5841238.png";